import api from 'Application/api/api';

const respondDecline = (signal, values) =>
	api.put('/inquiries/respond-decline', values, {
		signal,
	});

export default respondDecline;
